import { type SortableTagsCommonProps } from '../../types'

export interface ISortableTagContentProps<TagValue = any>
  extends SortableTagsCommonProps<{
    value: TagValue
    sortIndex?: number
  }> {}

export const SortableTagContent = <TagValue,>({
  innerProps: { value },
}: ISortableTagContentProps<TagValue>) => {
  return value
}
